import React, { useState } from "react";
import { View } from "react-native";

import { UserInfoQuestions, OpenEndedScreens, QuestionKind } from "consts";
import { MediaTray, MediaPreview, CameraButton, AudioButton } from "components";
import { useOtherTextResponse, useMediaProps } from "screens/question/hooks";
import {
  Container,
  Label,
  StyledTextInput,
  StyledTextInputContainer,
} from "./styled";

import { styles } from "components/other-text/styles";
import { isValidName } from "../../../../../utils";

export const TextInputQuestion = ({ question, section }) => {
  const { value, placeholder, onChange } = useOtherTextResponse(question);
  const isMultiline = OpenEndedScreens[question.app_screen_type];
  const isUserInfoScreen = section.questions.some(
    q => UserInfoQuestions[q.app_screen_type],
  );
  const isNameKind = question.kind === QuestionKind.NAME;

  return (
    <Container $fullWidth={!isUserInfoScreen}>
      <TextInputWithMedia
        value={value}
        question={question}
        onChangeText={txt => {
          if (
            !(isNameKind && isValidName(txt)) &&
            txt.length <= ((isNameKind && 100) || 1000)
          ) {
            return onChange(txt);
          }
        }}
        multiline={isMultiline}
        placeholder={placeholder}
      />
    </Container>
  );
};

export const TextInputWithMedia = ({
  value,
  multiline,
  placeholder,
  onChangeText,
  $fontSize,
  question,
  option,
  subOption,
  ...props
}) => {
  const mediaProps = useMediaProps(question, option, subOption);

  const [focus, setFocus] = useState(false);
  const multilineProps = multiline ? { multiline: true, numberOfLines: 6 } : {};

  return (
    <>
      <Label
        pointerEvents="none"
        $fontSize={$fontSize}
        $isFocused={focus || value}
      >
        {placeholder}
      </Label>
      <StyledTextInputContainer $isFocused={focus || value}>
        <StyledTextInput
          value={value}
          $fontSize={$fontSize}
          multiline={multiline}
          onChangeText={onChangeText}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          {...multilineProps}
          {...props}
        />
        <MediaTray {...mediaProps} />
      </StyledTextInputContainer>
      {mediaProps.hasMedia && <MediaGallery {...mediaProps} />}
    </>
  );
};

const MediaGallery = ({
  mediaFiles,
  audioFile,
  removeFile,
  audioEnabled,
  onCapture,
  photo,
  video,
}) => {
  return (
    <>
      <View style={styles.previewsContainer}>
        <View style={styles.previews}>
          {mediaFiles.map(file => {
            return (
              <MediaPreview
                key={file.id}
                media={file}
                remove={() => removeFile(file.id)}
              />
            );
          })}
        </View>
        {!!mediaFiles.length && (
          <View style={styles.cameraButton}>
            <CameraButton photo={photo} video={video} onCapture={onCapture} />
          </View>
        )}
        {audioEnabled && (
          <View style={styles.previews}>
            <AudioButton
              savedClip={audioFile.uri}
              onCapture={onCapture}
              removeFile={() => removeFile(audioFile.id)}
            />
          </View>
        )}
      </View>
    </>
  );
};
